
<template>
  <div id="app">
    <nav class="bg navbar liss ">
      <div class="navbar-header topbar-left">
        <a class="navbar-brand  slideInLeft" href="#">
          <img alt="Brand" src="./assets/images/logo.png">
        </a>
      </div>

      <div class="container">
        <ul class="lis">
          <li @click="checkNav()" v-bind:class="{'active': Index=='#/home' ? 'active': Index=='#/'}">
            <router-link to="/home"> 首页</router-link>
          </li>
          <li @click="checkNav()" v-bind:class="{'active':Index=='#/introduce'}">
            <router-link to="/introduce">公司简介</router-link>
          </li>
          <li @click="checkNav()" v-bind:class="{'active':Index=='#/product'}">
            <router-link to="/product">产品中心</router-link>
          </li>
          <li @click="checkNav()" v-bind:class="{'active':Index=='#/programme'}">
            <router-link to="/programme">方案中心</router-link>
          </li>
          <li @click="checkNav()" v-bind:class="{'active':Index=='#/news'}">
            <router-link to="/news">新闻资讯</router-link>
          </li>
          <li @click="checkNav()" v-bind:class="{'active':Index=='#/contact'}">
            <router-link to="/contact">联系我们</router-link>
          </li>
        </ul>

      </div>
      <div class="topbar-right">
        <a class="di" href="#">
          <img src="./assets/images/call.png" alt="">全国免费咨询热线:&emsp;0755-86235167
        </a>
      </div>
      <div id="box" class="box">
        <div class="box-in"></div>
      </div>
    </nav>
    <!-- 内容区 -->
    <router-view />

    <!-- 底部栏 -->
    <footer>
      <article>
        <div class="foo">
          <div class="footer-left ">
            <h5>联系方式</h5>
            <ul>
              <li>深圳市易联通达物流科技发展有限公司</li>
              <li>电话：0755-86235167</li>
              <li>邮箱：223640822@qq.com</li>
              <li>地址：深圳市龙岗区平湖街道海源城国际金融中心T1栋1212-1213</li>
            </ul>
          </div>
          <div class="footer-center">
            <h5>导航链接</h5>
            <div class="footer-center-con">
              <div class="footer-conL">
                <ul>
                  <li>网站首页</li>
                  <li>方案中心</li>
                  <li>联系我们</li>
                </ul>
              </div>
              <div class="footer-conC">
                <ul>
                  <li>公司简介</li>
                  <li>招商加盟</li>
                </ul>
              </div>
              <div class="footer-conR">
                <ul>
                  <li>产品中心</li>
                  <li>招贤纳士</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="footer-right">
            <h5>关注我们</h5>
            <img src="./assets/images/weixin.jpg" alt="">
          </div>
        </div>

      </article>
      <div class="copy">
        Copyright 2016-2021 yltd360.com &copy; 版权所有，深圳市易联通达物流科技发展有限公司，粤ICP备15004678号
      </div>
    </footer>

  </div>
</template>

<script>
import Vue from "vue";
export default {
  name: "App",
  data() {
    return {
      Index: document.location.hash,
    };
  },
  mounted() {
    var timer = null;
    box.onclick = function () {
      cancelAnimationFrame(timer);
      timer = requestAnimationFrame(function fn() {
        var oTop =
          document.body.scrollTop || document.documentElement.scrollTop;
        if (oTop > 0) {
          document.body.scrollTop = document.documentElement.scrollTop =
            oTop - 50;
          timer = requestAnimationFrame(fn);
        } else {
          cancelAnimationFrame(timer);
        }
      });
    };
    function gdjz(div, cssname, offset) {
      var a, b, c, d;
      d = $(div).offset().top;
      a = eval(d + offset); //元素相对于窗口的距离
      b = $(window).scrollTop(); //窗口已滚动的距离
      c = $(window).height(); //整个文档的高度

      if (b + c > a) {
        $(div).addClass(cssname);
      }
    }

    $(document).ready(function (e) {
      // $goToTop.stop().animate({opacity : 1},200);
      $(window).scroll(function () {
        gdjz(
          ".title2",
          "animate__animated animate__fadeIn animate__slower",
          100
        );
        gdjz(
          ".col-md-4",
          "animate__animated animate__fadeInUp animate__slower",
          100
        );
        gdjz(
          ".title3",
          "animate__animated animate__fadeInUp animate__slow",
          200
        );
        gdjz(
          ".title4",
          "animate__animated animate__fadeInUp animate__slower",
          200
        );
        gdjz(
          ".col-md-6",
          "animate__animated animate__fadeInLeft animate__slower",
          200
        );
        gdjz(".title5", "animate__animated animate__fadeInUp", 100);
      });
    });
  },
  methods: {
    checkNav(index) {
      this.Index = document.location.hash;
    },
  },
};
</script>

<style>
@media screen and (max-width: 500px) {
  * {
    font-size: 0.2rem;
  }
  a {
    font-size: 0.2rem !important;
  }
  .topbar-right {
    width: 59% !important;
    margin-top: 2rem !important;
    margin-left: 14rem;
    position: absolute;
  }
  .topbar-left {
    width: 100% !important;
    margin-left: 0 !important;
  }

  .liss {
    display: flex;
    flex-wrap: wrap !important;
  }
  .col-lg-1,
  .col-lg-10,
  .col-lg-11,
  .col-lg-12,
  .col-lg-2,
  .col-lg-3,
  .col-lg-4,
  .col-lg-5,
  .col-lg-6,
  .col-lg-7,
  .col-lg-8,
  .col-lg-9,
  .col-md-1,
  .col-md-10,
  .col-md-11,
  .col-md-12,
  .col-md-2,
  .col-md-3,
  .col-md-4,
  .col-md-5,
  .col-md-6,
  .col-md-7,
  .col-md-8,
  .col-md-9,
  .col-sm-1,
  .col-sm-10,
  .col-sm-11,
  .col-sm-12,
  .col-sm-2,
  .col-sm-3,
  .col-sm-4,
  .col-sm-5,
  .col-sm-6,
  .col-sm-7,
  .col-sm-8,
  .col-sm-9,
  .col-xs-1,
  .col-xs-10,
  .col-xs-11,
  .col-xs-12,
  .col-xs-2,
  .col-xs-3,
  .col-xs-4,
  .col-xs-5,
  .col-xs-6,
  .col-xs-7,
  .col-xs-8,
  .col-xs-9 {
    min-height: 0 !important;
    padding-right: 0 !important;
    padding-left: 0 !important;
  }
}

.bg {
  background-color: #fff;
}
.box {
  position: fixed;
  right: 1rem;
  bottom: 10rem;
  height: 5rem;
  width: 5rem;
  text-align: center;
  padding-top: 20px;
  background-color: gray;
  border-radius: 20%;
  overflow: hidden;
  cursor: pointer;
}
.box:hover:before {
  top: 50%;
}
.box:hover .box-in {
  visibility: hidden;
}
.box:before {
  position: absolute;
  top: -50%;
  left: 50%;
  transform: translate(-50%, -50%);
  content: "回到顶部";
  width: 40px;
  color: rgba(60, 85, 228, 0.938);
  font-weight: bold;
}
.box-in {
  visibility: visible;
  display: inline-block;
  height: 20px;
  width: 20px;
  border: 3px solid black;
  border-color: white transparent transparent white;
  transform: rotate(45deg);
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  margin-top: 0px;
  font-size: 14px;
  background: rgb(255, 255, 255);
  font-family: 微软雅黑;
  -ms-transform: translate3d(0, 0, 0); /* IE 9 */
  -moz-transform: translate3d(0, 0, 0); /* Firefox */
  -webkit-transform: translate3d(0, 0, 0); /* Safari 和 Chrome */
  -o-transform: translate3d(0, 0, 0); /* Opera */
  margin: 0 auto;
}
.navbar {
  border: 0;
}
* {
  margin: 0;
  padding: 0;
}
a {
  text-decoration: none !important;
  color: #333;
}
ol,
ul {
  margin-bottom: 0 !important;
}
a:hover {
  text-decoration: none !important;
  color: #333;
  cursor: pointer;
}

.introduce-nav li:hover a {
  color: #162987;
}
ul li {
  list-style-type: none;
}
.lis {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.liss {
  display: flex;
}
.topbar-left {
  width: 47%;
  margin-left: 50px;
  color: #333333;
}
.topbar-left img {
  width: 12rem;
}
.topbar-left a {
  font-size: 14px;
  color: black !important;
}
.navbar-brand > img {
  display: inline-block !important;
}
.navbar-default {
  background-color: #fff;
  border-color: #fff;
}
.topbar-right {
  width: 50%;
  margin-top: 19px;
}
.topbar-right a {
  font-size: 15px;
  color: black !important;
}
.topbar-right img {
  width: 20px;
}
.navbar {
  min-height: 55px;
  margin-bottom: 0 !important;
}
.navbar ul li {
  display: inline-block;
}
.navbar ul li a {
  padding: 15px;
  line-height: 60px;
  color: black !important;
}
.navbar ul li.active a {
  color: rgba(60, 85, 228, 0.938) !important;
}
.navbar ul li.active {
  border-bottom: 3px solid rgba(60, 85, 228, 0.938);
}
/* .navbar ul li.active a:after {
  content: "";
  display: block;
  position: relative;
  bottom: -10px;
  width: 68px;
  height: 2.5px;
  background: #0f2473;
  margin: 0 auto;
} */
/* body {
  padding-top: 60px;
} */

/* .navbar ul li a:hover {
  background-color: #080808;
} */

/*底部栏*/

footer article {
  clear: both;
  background: rgb(33, 33, 33);
  color: #ffffff;
}
footer .foo {
  display: fixed;
  bottom: 0;
  margin: 0 auto;
  width: 60%;
  display: flex;
  flex-wrap: wrap;
  padding: 20px 0;
}
footer .footer-left,
.footer-right,
.footer-center {
  text-align: left;
}
footer .footer-left {
  flex: 1;
  line-height: 25px;
}
footer .footer-center {
  flex: 1.3;
  text-align: center;
}
footer .footer-right {
  flex: 0.8;
  text-align: center;
}
footer .footer-right img {
  width: 100px;
  position: relative;
  right: -20px;
}
footer .footer-center h5 {
  text-align: left;
  padding: 5px 20px;
}
footer .footer-center-con {
  display: flex;
}

/* footer .footer-conL,
footer .footer-conR {
  flex: 1;
} */
footer .footer-conR ul li,
footer .footer-conL ul li,
footer .footer-conC ul li {
  text-align: left;
  padding: 5px 20px;
}

footer .footer-conR ul li {
  text-align: center;
  margin: 0 auto;
}
footer .copy {
  height: 30px;
  background: #ffffff;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue